export default "__VITE_ASSET__BCxOxjgj__"